import { BaseApi } from './base.api.js';
import { ApiError } from '../errors/api-error.js';

export class DataSubjectRequestApi extends BaseApi {
    constructor(client) {
        super(client, '/data-subject-request');
    }

    async getResponseLetter(id) {
        try {
            const response = await this.client.get(
                `${this.basePath}/${id}/response-letter`,
                { responseType: 'text' },
            );
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }
}
